/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_PartialInputs */

const en_cmp_partial = /** @type {(inputs: Cmp_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const id_cmp_partial = /** @type {(inputs: Cmp_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebagian`)
};

/**
* | output |
* | --- |
* | "Partial" |
*
* @param {Cmp_PartialInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_partial = /** @type {((inputs?: Cmp_PartialInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_PartialInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_partial(inputs)
	return en_cmp_partial(inputs)
});